import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 获取连锁供应商列表
export function listChainSupplier(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainSupplier.listChainSupplier',
      method: 'get',
      params: {
        ...params,
        csId: '',
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取连锁商品列表
export function listChainProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainProduct.listChainProduct',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取商品详情
export function queryProductDeatil(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainProduct.queryProductDeatil',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取商品价格策略列表
export function listProductPriceRule(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productPriceRule.listProductPriceRule',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存连锁供应商订单
export function saveChainInoutOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainInoutOrder.saveChainInoutOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}